import React from 'react';
import "./Components/style/style.scss";
import Auswahl from "./Components/Main/Auswahl";
import {BrowserRouter, Route} from "react-router-dom";
// import Footer from "./Components/Footer/Footer";
import Header from  "./Components/Header/Header";
import Zaune from "./Components/Main/Products/Zaune/index";
import Tore from "./Components/Main/Products/Tore/index";
import Pforten from "./Components/Main/Products/Pforten/index";
import Gelaender from "./Components/Main/Products/Gelaender/index";
import Vordaecher from "./Components/Main/Products/Vordaecher/index";
import Stahltreppe from "./Components/Main/Products/Stahltreppen";
import {connect} from "react-redux";
import Merkliste from "./Components/Main/Merkliste/merkliste";

const App = () => {

  return (
    <BrowserRouter>
      <div className='MainWrapper'>
          <Header />
          <Route exact path="/" render={() => <Auswahl />} />
          <Route path="/merkliste" render={() => <Merkliste />}/>
          <Route path="/zaune" render={() => <Zaune />}/>
          <Route exact path="/tore" render={() => <Tore />}/>
          <Route path="/pforten" render={() => <Pforten />} />
          <Route exact path="/gelaender" render={() => <Gelaender />} />
          <Route path="/vordaecher" render={() => <Vordaecher />} />
          <Route path="/stahltreppe" render={() => <Stahltreppe />} />
      </div>
      {/* <Footer /> */}
      </BrowserRouter>
  );
}

const mapStateToProps = state => {
    return {
        link: state.mainReducer.link,
        titel: state.mainReducer.titel
    }
}

// const mapDispatchToProps = dispatch => {
//     return {

//     }
// }


export default connect(mapStateToProps, null)(App);
